
import Facebook from "../../../assets/filled/Facebook.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function FacebookIcon({ className, dataTestid = "FacebookIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Facebook data-testid={dataTestid} className={classes} {...rest} />
  );
}
